import enums from '@/mixins/enums';
import getDistributionChannelData from '@/utils/getDistributionChannelData';

export default {
  mixins: [enums],
  computed: {
    isVIP() {
      const { DistributionChannelEnum } = this.enums;
      return this.model.distributionChannel === DistributionChannelEnum.VIP;
    },
  },
  methods: {
    distributionChannelsInitialization() {
      // const {
      //   hash, meno, priezvisko, cislo, email, telefon, channel, verzia,
      // } = this.$route.query;
      //
      // // Initialization broker with hash
      // if (hash && typeof hash === 'string') {
      //   const decodedHash = atob(hash);
      //   const urlParams = new URLSearchParams(decodedHash);
      //
      //   const getParam = (paramName) => urlParams?.get(paramName)?.split('#')[0];
      //

      // }
      //
      // // Initialization broker with queries
      // if (meno && priezvisko && cislo) {
      //   this.model.broker.name = meno;
      //   this.model.broker.surname = priezvisko;
      //   this.model.broker.number = cislo;
      //   this.model.broker.phone = telefon;
      // }

      const {
        hash,
      } = this.$route.query;

      this.model.hash = hash;

      const { DistributionChannelEnum } = this.enums;
      const {
        name, surname, number, email,
        phone, callcentrumBroker, channel,
      } = getDistributionChannelData(this.$route);

      // Set distribution channel data to broker
      this.model.broker.name = name;
      this.model.broker.surname = surname;
      this.model.broker.number = number;
      this.model.broker.email = email;
      this.model.broker.phone = phone;
      this.model.broker.callcentrumBroker = callcentrumBroker;

      // Set distribution channel
      if (channel === 'vip') this.model.distributionChannel = DistributionChannelEnum.VIP;

      if (email) {
        this.model.broker.email = email;
      }
    },
  },
};
